
    import { Component, Vue } from 'vue-property-decorator';

    @Component({})
    export default class NotificationItem extends Vue {
        link: string | null = null;
    }
